import { getStore } from "../store/appStore";
import { AppAction } from "../types";
import { EnableLspActionKey as ActionKey } from "./ActionKeys";

export interface SetEnableLsp
  extends AppAction<ActionKey.SET_ENABLE_LSP, { enableLsp: boolean }> {}

export const setEnableLsp = (enableLsp: boolean): SetEnableLsp =>
  getStore().dispatch({
    type: ActionKey.SET_ENABLE_LSP,
    payload: { enableLsp },
  });
